import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=47ce78f0&scoped=true"
import script from "./GenericModal.vue?vue&type=script&lang=js"
export * from "./GenericModal.vue?vue&type=script&lang=js"
import style0 from "./GenericModal.vue?vue&type=style&index=0&id=47ce78f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce78f0",
  null
  
)

export default component.exports